import { styled } from "@mui/material";
const Container = styled("div", {
  slot: "Root",
  skipSx: true,
  name: "TruncateContainer",
  shouldForwardProp: (prop) => prop !== "listAlignment"
})(
  ({ listAlignment = "start" }) => `
  position: relative;
  display: flex;
  width: 100%;
  height: inherit;
  padding: 0px;
  overflow: hidden;
  justify-content: ${listAlignment === "start" ? "flex-start" : "flex-end"};
`
);
export {
  Container
};
//# sourceMappingURL=Container.js.map
